import { makeStyles } from '@material-ui/core/styles';

const linkDefault = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  textTransform: 'uppercase',
  textDecoration: 'none',
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.container.background,
    fontSize: '1.125rem',
    height: '3.75rem',
    justifyContent: 'space-between',
    width: '100%',
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    width: 'calc(100% - 4rem)',
    height: '100%',
    maxWidth: '100rem',
    margin: '0 auto',
    gap: '2rem',
  },
  link: {
    ...linkDefault,
    color: theme.palette.primary.main,
  },
  selectedLink: {
    ...linkDefault,
    color: theme.palette.text.primary,
    borderStyle: 'solid',
    borderWidth: '0 0 2px 0',
    borderColor: theme.palette.secondary.main,
  },
}));

export default useStyles;
